"use client"

import { useState, useEffect } from "react"
import { uploadVideo, updateVideo } from "../comman/LearningVedio.js"

const VideoModal = ({ isModalOpen, setIsModalOpen, videoToEdit, onAddVideo, onUpdateVideo }) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    videoTitle: "",
    videoCategory: "",
    videoLink: "",
  })

  useEffect(() => {
    if (videoToEdit) {
      setFormData({
        videoTitle: videoToEdit.videoTitle || "",
        videoCategory: videoToEdit.videoCategory || "",
        videoLink: videoToEdit.videoLink || "",
      })
    } else {
      setFormData({
        videoTitle: "",
        videoCategory: "",
        videoLink: "",
      })
    }
  }, [videoToEdit])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      if (videoToEdit) {
        const updatedVideo = await updateVideo(videoToEdit._id, formData)
        await onUpdateVideo(updatedVideo)
      } else {
        const newVideoData = { ...formData, _id: Date.now().toString() }
        const response = await uploadVideo(newVideoData)
        await onAddVideo(response)
      }
      setIsModalOpen(false)
    } catch (error) {
      console.error("Error submitting video:", error)
      alert("Failed to submit the video")
    } finally {
      setLoading(false)
    }
  }

  if (!isModalOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-gray-800">{videoToEdit ? "Edit Video" : "Add Video"}</h2>
            <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="videoTitle" className="block text-sm font-medium text-gray-700 mb-1">
                Video Title
              </label>
              <input
                type="text"
                id="videoTitle"
                name="videoTitle"
                value={formData.videoTitle}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter video title"
                required
              />
            </div>
            <div>
              <label htmlFor="videoCategory" className="block text-sm font-medium text-gray-700 mb-1">
                Video Category
              </label>
              <input
                type="text"
                id="videoCategory"
                name="videoCategory"
                value={formData.videoCategory}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter video category"
                required
              />
            </div>
            <div>
              <label htmlFor="videoLink" className="block text-sm font-medium text-gray-700 mb-1">
                Video Link
              </label>
              <input
                type="url"
                id="videoLink"
                name="videoLink"
                value={formData.videoLink}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                placeholder="Enter video link"
                required
              />
            </div>
          </form>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
          <button
            type="submit"
            onClick={handleSubmit}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#12143F] text-base font-medium text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:ml-3 sm:w-auto sm:text-sm"
            disabled={loading}
          >
            {loading ? "Submitting..." : videoToEdit ? "Update Video" : "Add Video"}
          </button>
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default VideoModal

